var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.general_fields.length > 0
    ? _c(
        "b-tabs",
        { attrs: { pills: "", card: "", vertical: "" } },
        _vm._l(_vm.general_fields, function (item, idx) {
          return _c(
            "b-tab",
            {
              key: item.shipment_id,
              attrs: { "title-link-class": "", active: item.is_active },
            },
            [
              _c("template", { slot: "title" }, [
                _c("div", { staticClass: "fs-lg px-4 text-center" }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.__t(item.shipment_title)) +
                      "\n            "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "b-card-text",
                [
                  !_vm.is_qr
                    ? _c("yes_no", {
                        key: "PUBLISHED",
                        attrs: { title: "PUBLISHED" },
                        on: { input: _vm.on_change_value },
                        model: {
                          value: item.published,
                          callback: function ($$v) {
                            _vm.$set(item, "published", $$v)
                          },
                          expression: "item.published",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  item.published
                    ? _c(
                        "div",
                        [
                          _c("yes_no", {
                            key: "PAY_CACHE",
                            attrs: { title: "PAY_CACHE" },
                            on: { input: _vm.on_change_value },
                            model: {
                              value: item.pay_cache,
                              callback: function ($$v) {
                                _vm.$set(item, "pay_cache", $$v)
                              },
                              expression: "item.pay_cache",
                            },
                          }),
                          _vm._v(" "),
                          _c("yes_no", {
                            key: "PAY_ONLINE",
                            attrs: { title: "PAY_ONLINE" },
                            on: { input: _vm.on_change_value },
                            model: {
                              value: item.pay_online,
                              callback: function ($$v) {
                                _vm.$set(item, "pay_online", $$v)
                              },
                              expression: "item.pay_online",
                            },
                          }),
                          _vm._v(" "),
                          _c("yes_no", {
                            key: "PAY_TERMINAL",
                            attrs: { title: "PAY_TERMINAL" },
                            on: { input: _vm.on_change_value },
                            model: {
                              value: item.pay_terminal,
                              callback: function ($$v) {
                                _vm.$set(item, "pay_terminal", $$v)
                              },
                              expression: "item.pay_terminal",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            2
          )
        }),
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }